module.exports = __webpack_public_path__ + "static/pixeltree-82b05d1631c8e4cff8749e779bafe41b.svg";